export default __webpack_public_path__ + "static/media/nitzan1.f9edeac7.jpg";